module.exports = __webpack_public_path__ + "img/integralShop_actual_bg.70322f43.png";